import Icon from './Icon';

export default function MediaLoadingSpinner({ className = '' }) {
  return (
    <div
      aria-hidden="true"
      className={[
        'absolute inset-0 z-[2] flex items-center justify-center bg-surface-2 text-text-primary',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      data-testid="media-loading-spinner"
    >
      <Icon
        name="loader"
        size={42}
        className="animate-spin"
      />
    </div>
  );
}
